import React, { ReactElement, ReactNode } from 'react';
import { Link as MuiLink } from '@mui/material';
import { OverridableStyles } from '~/utils/types.ts';

export type StyledLinkProps<T> = T & {
  component: React.ElementType<T>;
  children?: ReactNode;
} & OverridableStyles;

/**
 * @description Applies proper link visuals through a CSS class to your provided `component`.
 * This is useful for next.js apps to style next.js links.
 */
const StyledLinkImpl = React.forwardRef<
  HTMLAnchorElement,
  StyledLinkProps<unknown>
>(({ styleOverrides, ...linkProps }, ref) => {
  return (
    <MuiLink
      ref={ref}
      color="secondary"
      underline="hover"
      sx={styleOverrides}
      {...linkProps}
    />
  );
});

StyledLinkImpl.displayName = 'StyledLink';

// type cast is needed so let the component type take in a generic type arg
// that is forwarded to its props
export const StyledLink = StyledLinkImpl as <T>(
  props: StyledLinkProps<T>,
) => ReactElement;
